// Время проекта — Екатеринбург (UTC+5, без перехода на летнее время).
// Люди работают из Екатеринбурга, а сервер и разработчик — в Москве, поэтому даты и время на экранах
// и «сегодня» считаются по Екатеринбургу независимо от часового пояса компьютера.
//
// Значения из API приходят в ISO 8601 со смещением («2026-10-08T14:24:00+03:00», «…Z») — это точные моменты;
// даты без времени («2026-10-20») — календарные дни и не зависят от часового пояса.

export const TZ_NAME = 'Asia/Yekaterinburg'
export const TZ_OFFSET_MS = 5 * 3600 * 1000

const DAY_MS = 24 * 3600 * 1000
const pad = (n) => String(n).padStart(2, '0')

// Момент → «настенное» время Екатеринбурга в виде Date, читать только через getUTC*.
function wall(value) {
  const d = value instanceof Date ? value : new Date(value)
  return isNaN(d) ? null : new Date(d.getTime() + TZ_OFFSET_MS)
}

// «08.10.2026 14:24» или «—».
export function formatDateTime(value) {
  if (!value) return '—'
  const w = wall(value)
  if (!w) return '—'
  return pad(w.getUTCDate()) + '.' + pad(w.getUTCMonth() + 1) + '.' + w.getUTCFullYear() + ' ' + pad(w.getUTCHours()) + ':' + pad(w.getUTCMinutes())
}

// Момент → значение поля datetime-local («2026-10-20T14:30») по Екатеринбургу; пусто — ''.
export function toInputDateTime(value) {
  const w = value ? wall(value) : null
  if (!w) return ''
  return w.getUTCFullYear() + '-' + pad(w.getUTCMonth() + 1) + '-' + pad(w.getUTCDate()) + 'T' + pad(w.getUTCHours()) + ':' + pad(w.getUTCMinutes())
}

// Значение поля datetime-local (по Екатеринбургу) → момент ISO со смещением +05:00; пусто — null.
export function fromInputDateTime(local) {
  if (!local) return null
  const text = String(local)
  return (text.length === 10 ? text + 'T00:00' : text) + ':00+05:00'
}

// «20.10.2026» или «20.10.2026 14:30»: время 00:00 — это дата без времени, его не показываем.
export function formatPlan(value) {
  return formatDateTime(value).replace(/ 00:00$/, '')
}

// Календарный день «2026-10-08» для момента (по умолчанию — сейчас).
export function dayString(value = new Date()) {
  const w = wall(value)
  return w ? w.getUTCFullYear() + '-' + pad(w.getUTCMonth() + 1) + '-' + pad(w.getUTCDate()) : ''
}

// Момент начала календарного дня «2026-10-08» в Екатеринбурге (00:00:00 +05:00).
export function startOfDay(day) {
  return new Date(day + 'T00:00:00+05:00')
}

// Момент конца календарного дня (23:59:59 +05:00).
export function endOfDay(day) {
  return new Date(day + 'T23:59:59+05:00')
}

// Начало сегодняшнего дня в Екатеринбурге.
export function startOfToday(now = new Date()) {
  return startOfDay(dayString(now))
}

// Сдвиг календарного дня на n суток: addDays('2026-10-31', 1) → '2026-11-01'.
export function addDays(day, n) {
  const d = new Date(day + 'T00:00:00Z')
  return new Date(d.getTime() + n * DAY_MS).toISOString().slice(0, 10)
}

// Параметры для toLocaleDateString календарного дня без времени: день не должен «съезжать» из-за пояса.
export const DAY_FORMAT = { timeZone: 'UTC' }
